export default function Card({ children, className = '', hover = true }) {
    return (
      <div className={`bg-white border border-gray-200 rounded-xl shadow-sm transition-all duration-300 ${hover ? 'hover:shadow-lg hover:border-micropoint-gold hover:-translate-y-1' : ''} ${className}`}>
        {children}
      </div>
    );
  }